var map = {
	"./aboutThisBoard.json": "tHWo",
	"./autoWatch.json": "s/LT",
	"./boardInvitees.json": "drJR",
	"./cardbackCTA.json": "1RbY",
	"./gammaHeader.json": "KAnv",
	"./gammaNotifications.json": "3zBa",
	"./improvedBoardSearchFormFactor.json": "0Jx5",
	"./inviteButton.json": "qBdL",
	"./npsSurvey.json": "bGHy",
	"./onboarding.json": "c7Lg",
	"./powerUpSuggestions.json": "eBu/",
	"./showApiErrors.json": "qfIv",
	"./softBlock.json": "CNOs",
	"./subscribeToWatchOrFollow.json": "i5iS",
	"./superHomeTeamCards.json": "XB8T",
	"./tacoHearts.json": "V3Ia",
	"./teamBoardContribution.json": "NqMj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2m93";


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config nonrecursive \.json$
// module id = 2m93
// module chunks = 13